module.exports = __webpack_public_path__ + "img/whats-new-1_jp.6320938.jpg";